import axios from 'axios'
import { msalInstance, apiRequest } from './msalConfig'

const client = axios.create({
    baseURL: import.meta.env.VITE_API_URL as string,
    headers: {
        'Content-Type': 'application/json',
    },
})

client.interceptors.request.use(async (config) => {
    const account = msalInstance.getActiveAccount()

    if (!account) return config

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...apiRequest,
            account,
        })
        config.headers.Authorization = `Bearer ${response.accessToken}`
    } catch {
        await msalInstance.acquireTokenRedirect(apiRequest)
    }

    return config
})

export default client
